<fs-dialog>
  <div class="fs-row.gap-sm heading">
    <app-logo></app-logo>
    <button
      mat-icon-button
      mat-dialog-close
      aria-label="Close"
      type="button"
      tabindex="-1">
      <mat-icon>
        clear
      </mat-icon>
    </button>
  </div>
  <mat-card>
    @if (step === 0) {
      <app-workspace
        [(environmentCreate)]="environmentCreate"
        (environmentCreateChange)="stepNext()">
      </app-workspace>
    }
    @if (step === 1) {
      <app-project
        [(environmentCreate)]="environmentCreate"
        (environmentCreateChange)="stepNext()">
      </app-project>
    }
    @if (step === 2) {
      <app-invite
        [environmentCreate]="environmentCreate"
        (completed)="close()">
      </app-invite>
    }
    <app-progress [step]="step"></app-progress>
  </mat-card>
</fs-dialog>